import { ChatType, MdUserRole } from '@anyx/common-graphql';
import { Restricted } from '@anyx/common-permission';
import { AIAutoReplyConfigFormContainer } from '@anyx/function-chat/shared';
import { Card } from '@anyx/shared-ui';

export const AdminSectionPage = () => {
  return (
    <Card withPadding={false}>
      <Restricted roles={[MdUserRole.ADMIN]}>
        <AIAutoReplyConfigFormContainer chatType={ChatType.LINE} />
      </Restricted>
    </Card>
  );
};
